export const TICKET_SOURCE = {
  QUEST_COMPLETION: "QUEST_COMPLETION",
  MANUAL_GRANT: "MANUAL_GRANT",
  VOUCHER_REDEMPTION: "VOUCHER_REDEMPTION",
  HOLD_TO_EARN_TOP_HOLDER: "HOLD_TO_EARN_TOP_HOLDER",
} as const;
export type TICKET_SOURCE = (typeof TICKET_SOURCE)[keyof typeof TICKET_SOURCE];
